import { cloneDeep } from "lodash";

const SET_FWU_CAMPAIGNS = "app/fwuCamnpaigns/FWU_CAMPAIGNS";
const SET_FWU_CAMPAIGN_TO_EDIT = "app/fwuCamnpaigns/SET_FWU_CAMPAIGN_TO_EDIT";
const SET_FWU_CAMPAIGN_DETAILS = "app/fwuCamnpaigns/SET_FWU_CAMPAIGN_DETAILS";
const PUSH_RELEASE_NOTES = "app/fwuCamnpaigns/PUSH_RELEASE_NOTES";
const RESET_FWU_CAMPAIGNS = "app/fwuCamnpaigns/RESET_FWU_CAMPAIGNS";
const RESET_RELEASE_NOTES_LIST = "app/fwuCamnpaigns/RESET_RELEASE_NOTES_LIST";
const SET_LOADING = "app/fwuCamnpaigns/SET_LOADING";
const SET_REFRESH = "app/fwuCamnpaigns/SET_REFRESH";
const SET_FWU_CAMPAIGN_DETAILS_REFRESH = "app/fwuCamnpaigns/SET_FWU_CAMPAIGN_DETAILS_REFRESH";
const SET_ERROR = "app/fwuCamnpaigns/SET_ERROR";

const initialState = {
  fwuCampaigns: null,
  fwuCampaignToEdit: null,
  fwuCampaignDetails: null,
  releaseNotesList: {},
  loading: false,
  refresh: false,
  fwuCampaignDetailsRefresh: false,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_FWU_CAMPAIGNS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwuCampaigns: action.payload
      };
    }

    case RESET_FWU_CAMPAIGNS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwuCampaigns: null
      };
    }

    case SET_FWU_CAMPAIGN_TO_EDIT: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwuCampaignToEdit: action.payload
      };
    }

    case SET_FWU_CAMPAIGN_DETAILS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwuCampaignDetails: action.payload
      };
    }

    case PUSH_RELEASE_NOTES: {
      const clonedState = cloneDeep(state);
      const { version, releaseNotes } = action.payload ?? {};

      const newReleaseNotesList = { ...clonedState.releaseNotesList, [version]: releaseNotes };

      return {
        ...clonedState,
        releaseNotesList: newReleaseNotesList
      };
    }

    case RESET_RELEASE_NOTES_LIST: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        releaseNotesList: {}
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_FWU_CAMPAIGN_DETAILS_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwuCampaignDetailsRefresh: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const setFWUCampaigns = (fwuCampaigns) => ({
  type: SET_FWU_CAMPAIGNS,
  payload: fwuCampaigns
});

export const setFWUCampaignToEdit = (fwuCampaign) => ({
  type: SET_FWU_CAMPAIGN_TO_EDIT,
  payload: fwuCampaign
});

export const setFWUCampaignDetails = (fwuCampaignDetails) => ({
  type: SET_FWU_CAMPAIGN_DETAILS,
  payload: fwuCampaignDetails
});

export const pushReleaseNotes = (releaseNotesConfig) => ({
  type: PUSH_RELEASE_NOTES,
  payload: releaseNotesConfig
});

export const resetFWUCampaigns = () => ({ type: RESET_FWU_CAMPAIGNS });

export const resetReleaseNotesList = () => ({ type: RESET_RELEASE_NOTES_LIST });

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setFwuCampaignDetailsRefresh = (refresh) => ({
  type: SET_FWU_CAMPAIGN_DETAILS_REFRESH,
  payload: refresh
});

export const setError = (error) => ({ type: SET_ERROR, payload: error });
